import { useDispatch } from "react-redux";
import { setLoading } from "../redux/slices/ui";
import { useEffect, useState } from "react";
import { onAuthStateChanged, signInWithEmailAndPassword } from "firebase/auth";
import { useLocation, useNavigate } from "react-router-dom";
import { auth } from "../firebaseConfig";
import { AUTH_EMAIL, PIN_LENGTH } from "../auth/authConstants";
import PinInput from "../components/ui/PinInput";

const emptyPin = () => Array(PIN_LENGTH).fill("");

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [pin, setPin] = useState(emptyPin);
  const [shake, setShake] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  // Once authenticated, leave the login screen (fresh sign-in or already logged in).
  useEffect(() => {
    const target = location.state?.from?.pathname || "/";
    return onAuthStateChanged(auth, (user) => {
      if (user) navigate(target, { replace: true });
    });
  }, [navigate, location.state]);

  const reject = () => {
    setShake(true);
    setPin(emptyPin());
    setTimeout(() => setShake(false), 500);
  };

  const handleComplete = async (enteredPin) => {
    if (submitting) return;
    setSubmitting(true);
    dispatch(setLoading(true));
    try {
      await signInWithEmailAndPassword(auth, AUTH_EMAIL, enteredPin);
    } catch (err) {
      // Wrong PIN: the shake animation is the only feedback we want.
      reject();
    } finally {
      setSubmitting(false);
      dispatch(setLoading(false));
    }
  };

  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-3 bg-gradient-to-b from-brand-100 to-brand-50 px-6 py-12">
      <img src="/fish.svg" alt="Λίνος" className="h-20 w-20 drop-shadow-lg" />
      <h1 className="text-3xl font-extrabold tracking-[0.2em] text-brand-700">ΛΙΝΟΣ</h1>
      <p className="mb-4 text-slate-500">Εισάγετε το PIN σας</p>
      <PinInput value={pin} onChange={setPin} onComplete={handleComplete} shake={shake} autoFocus />
    </div>
  );
};

export default Login;
